import { Box, styled } from '@mui/material';
import _DownloadIcon from '@/assets/images/icons/downloadIcon.svg?react';
import _LinkIcon from '@/assets/images/icons/link_outer_icon.svg?react';

export const Wrapper = styled(Box)({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
    width: '100%',
    gap: '24px',
});

export const Card = styled(Box)(({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
    width: '100%',
    background: 'transparent',
    padding: '0 24px 16px',
    gap: '20px',
    [theme.breakpoints.down('md')]: {
        padding: '16px 0',
    },
}));

export const EmptyBox = styled(Box)(({ theme }) => ({
    display: 'flex',
    padding: '0 24px',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    margin: '36px 0',
    flexDirection: 'column',
    [theme.breakpoints.down('md')]: {
        padding: '0 24px',
    },
}));

export const DownloadIcon = styled(_DownloadIcon)(() => ({
    width: '16px',
    height: '16px',
}));

export const IconBox = styled(Box)({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
});

export const LinkIcon = styled(_LinkIcon)({});
export const PaymentsMobileRow = styled(Box)(({ theme }) => ({
    padding: '16px',
    borderBottom: `1px solid ${theme.palette.divider}`,
    '&:first-of-type': {
        borderTop: `1px solid ${theme.palette.divider}`,
    },
}));

export const Image = styled('img')({
    width: '100%',
    height: 'auto',
});
